import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import BrandBlogPage from './BrandBlogPage';

export default function BlogPage() {
  return (
    <>
      <Navbar />
      <BrandBlogPage
        publisher="千華駐科技"
        brandName="千華駐科技"
        englishName="CHIANVA"
        tagline="科技知識與實用閱讀，拓展理解世界的方式"
      />
      <Footer />
    </>
  );
}

